import { Link } from "react-router-dom";

export default function BlogCompareTrust() {
  return (
    <main className="min-h-screen bg-slate-50 text-slate-950">
      <section className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-5xl px-5 py-12 sm:px-6 lg:py-16">
          <p className="text-xs font-semibold uppercase tracking-[3px] text-cyan-700">
            AbroadJacks Blog
          </p>
          <h1 className="mt-3 max-w-4xl text-3xl font-semibold leading-tight text-slate-950 md:text-5xl">
            Why comparison and trust matter when choosing a study abroad platform
          </h1>
          <p className="mt-5 max-w-3xl text-base leading-7 text-slate-600">
            Students don&apos;t just need a list of consultancies. They need clear comparison and confidence that the platform is reliable. AbroadJacks is designed to help students compare options faster and make decisions with trust.
          </p>
          <div className="mt-6 flex flex-wrap gap-2 text-xs font-semibold text-slate-600">
            <span className="rounded-md border border-slate-200 bg-slate-50 px-3 py-1.5">Trust signals</span>
            <span className="rounded-md border border-slate-200 bg-slate-50 px-3 py-1.5">Transparent profiles</span>
            <span className="rounded-md border border-slate-200 bg-slate-50 px-3 py-1.5">Student-first search</span>
          </div>
        </div>
      </section>

      <article className="mx-auto max-w-5xl px-5 py-10 sm:px-6">
        <div className="grid gap-8 lg:grid-cols-[1fr_280px]">
          <div className="rounded-lg border border-slate-200 bg-white p-6 shadow-sm md:p-8">
            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">
            Comparison should be simple, not confusing
              </h2>
              <p className="leading-7 text-slate-700">
            In traditional search, students jump across websites, social pages,
            and referrals. AbroadJacks brings consultancy details and offers
            into one place so students can compare destination focus, services,
            and active opportunities without wasting time.
              </p>
              <ul className="grid gap-2 text-sm text-slate-700 sm:grid-cols-2">
            <li>Compare multiple consultancies side by side.</li>
            <li>Review active offers in one dashboard.</li>
            <li>Shortlist by country and course goals.</li>
            <li>Connect using direct contact details.</li>
              </ul>
            </section>

            <section className="mt-8 space-y-4">
              <h2 className="text-2xl font-semibold">
            Trust is the foundation of student decisions
              </h2>
              <p className="leading-7 text-slate-700">
            Choosing a consultancy affects admissions, finances, and visa
            timelines. That is why trust matters. AbroadJacks focuses on
            transparent profiles, clear contact visibility, and a structured
            marketplace flow that helps students avoid random or unclear
            sources.
              </p>
            </section>

            <section className="mt-8 space-y-4">
              <h2 className="text-2xl font-semibold">
            How AbroadJacks supports confident choices
              </h2>
              <p className="leading-7 text-slate-700">
            AbroadJacks combines discoverability and credibility. Students can
            evaluate options, compare strengths, and contact consultancies
            directly while staying inside one platform experience.
              </p>
            </section>
          </div>

          <aside className="h-max rounded-lg border border-slate-200 bg-white p-5 shadow-sm">
            <p className="text-sm font-semibold text-slate-950">Compare with clearer context</p>
            <p className="mt-2 text-sm leading-6 text-slate-600">
              Use AbroadJacks to review profile information, offers, and public-source signals in one place.
            </p>
            <div className="mt-5 grid gap-3">
            <Link
              to="/consultancies"
                className="rounded-lg bg-slate-950 px-4 py-2.5 text-center text-sm font-semibold text-white transition hover:bg-slate-800"
            >
              Compare Consultancies
            </Link>
            <Link
              to="/register"
                className="rounded-lg border border-slate-300 px-4 py-2.5 text-center text-sm font-semibold text-slate-900 transition hover:bg-slate-50"
            >
              Create Free Account
            </Link>
            </div>
          </aside>
          </div>
      </article>
    </main>
  );
}
